import { useEffect, useState } from 'react';
import { readAccessToken } from '@/utils/auth-token-store';
import { isShowcaseEmbedActive } from '@/utils/showcase-embed';
// In vriti.ai's showcase frame the landing is a preview for visitors: never signed in there.
const hasSession = () => !isShowcaseEmbedActive() && !!readAccessToken();
const useAuthStatus = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(hasSession);
    useEffect(() => {
        const checkLogin = () => {
            setIsLoggedIn(hasSession());
        };
        checkLogin();
        // Optional: listen for storage changes (multi-tab login/logout sync)
        window.addEventListener('storage', checkLogin);
        window.addEventListener('authChange', checkLogin);
        return () => {
            window.removeEventListener('storage', checkLogin);
            window.removeEventListener('authChange', checkLogin);
        };
    }, []);
    return isLoggedIn;
};
export default useAuthStatus;
